<div class="loading-container">
  <mat-spinner></mat-spinner>
  <div class="loading-text" *ngIf="showText">{{constants.LOADING}}</div>
</div>
